import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util'

const container = theme => css`
  margin: ${rem(56)} auto ${rem(10)};
  color: ${theme.color.monochrome.black};
  max-width: ${rem(430)};
`

const copy = theme => css`
  font-size: ${theme.fontSize.x2large};

  @media only screen and (min-width: ${theme.breakpoints.tabletBreakpoint}) {
    margin-right: ${rem(-24)};
  }
`

const formWrapper = css`
  max-width: ${rem(396)};
`

const heading = theme => css`
  font-size: ${rem(19)};
  font-weight: ${theme.fontWeight.medium};
  line-height: ${theme.lineHeight.leadingNormal};
  margin: ${rem(24)} -${rem(10)} ${rem(16)} 0;

  & span {
    font-size: ${theme.fontSize.x2large};
    font-weight: ${theme.fontWeight.normal};
  }
`

const field = theme => css`
  && {
    max-width: 100%;

    &:hover {
      & > * {
        border-color: ${theme.color.primary.info};
      }
    }
    .focused {
      border-color: ${theme.color.primary.info};
    }
    input {
      height: ${rem(48)};
      padding-left: ${rem(16)};
      font-size: ${theme.fontSize.x2large};

      &::placeholder {
        opacity: 0.5;
      }
    }
  }
`

const submitButton = css`
  width: 100%;
  border-radius: ${rem(24)};
`

const radios = css`
  display: flex;
  flex-wrap: wrap;
  gap: ${rem(12)};
  margin-top: ${rem(16)};
`

const radioBtn = theme => css`
  label {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: ${rem(108)};
    height: ${rem(50)};
    border-radius: ${rem(26)};
    border: 1px solid ${theme.color.monochrome.medium};
    font-weight: ${theme.fontWeight.medium};
    cursor: pointer;
    transition: border 0.1s, color 0.2s;

    @media only screen and (min-width: 420px) {
      min-width: ${rem(124)};
    }

    &:hover {
      border-color: ${theme.color.primary.info};
    }
  }

  input {
    display: none;

    &:checked + label {
      color: ${theme.color.primary.info};
      border-color: currentColor;
      border-width: 2px;
    }
  }
`

export const styles = {
  container,
  copy,
  formWrapper,
  heading,
  field,
  submitButton,
  radios,
  radioBtn,
}
